import encryptDecrypt from "./encryptDecrypt";

const KEY = 'last_client_id';
const SESSION_KEY = 'session_client_id';

export const saveLastClientId = (id: string) => {
  const encrypted = encryptDecrypt.encryptClientId(id);
  localStorage.setItem(KEY, encrypted);
  sessionStorage.setItem(SESSION_KEY, encrypted);
};

export const getLastClientId = (): string | null => {
  const clientId = localStorage.getItem(KEY)
  if (!clientId) return null
  return encryptDecrypt.decryptClientId(clientId);
};

export const getLastEncryptedClientId = (): string | null => {
  return sessionStorage.getItem(SESSION_KEY) ?? localStorage.getItem(KEY) ?? null;
};

export const getSessionClientId = (): string | null => {
  const encrypted = sessionStorage.getItem(SESSION_KEY);
  if (!encrypted) return null;
  return encryptDecrypt.decryptClientId(encrypted);
};

export const clearLastClientId = () => {
  localStorage.removeItem(KEY);
  sessionStorage.removeItem(SESSION_KEY);
};